import React from "react";
import { Chip, Stack, Typography } from "@mui/material";
import { getLanguageFlag } from "../../../utils/languageFlags";
import * as S from "../style";

interface LanguageCount {
  language: string;
  count: number;
}

interface LanguageStatsProps {
  topLanguages: LanguageCount[];
}

const LanguageStats: React.FC<LanguageStatsProps> = ({ topLanguages }) => {
  if (topLanguages.length === 0) return null;

  return (
    <S.StyledLanguageStatsPaper elevation={0}>
      <Typography {...S.StyledLanguageStatsLabel}>Top Languages</Typography>
      <Stack {...S.StyledLanguageStatsStack}>
        {topLanguages.map((lang) => {
          const flag = getLanguageFlag(lang.language);
          return (
            <Chip
              key={lang.language}
              label={`${flag}${flag ? ' ' : ''}${lang.language.toUpperCase()}: ${lang.count}`}
              size="small"
              sx={{
                bgcolor: 'action.selected',
                color: 'text.secondary',
                fontWeight: 600,
                borderRadius: "8px",
              }}
            />
          );
        })}
      </Stack>
    </S.StyledLanguageStatsPaper>
  );
};

export default LanguageStats;
